export default __webpack_public_path__ + "3b176ae2cc4eea1f9998723d9eb6bd42.png";